export const API_BASE_URL = 'https://dev-back.plzez.com';
export const API_AUTH_BASE_URL = 'https://dev-back.plzez.com';

export const API_BASE_URL_DEV = 'https://dev-back.plzez.com';
export const API_AUTH_BASE_URL_DEV = 'https://dev-back.plzez.com';

export const ACCESS_TOKEN = 'accessToken';


export const NAVER_AUTH_URL = API_BASE_URL_DEV + '/oauth2/authorize/naver?redirect_uri=https://dev-back.plzez.com/oauth2/callback/naver';
export const KAKAO_AUTH_URL = API_BASE_URL_DEV + '/oauth2/authorize/kakao?redirect_uri=https://dev-back.plzez.com/oauth2/callback/kakao';
